//
//
//
//
//
//

  export default {
    data () {
      return {
        show: false,
        message: ''
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/common/toast/toast.vue